import $ from 'jquery';
import { loadSlick } from './utils/slickLoader.js';

// Übergangsvarianten zur Abstimmung mit dem Kunden, umschaltbar per URL:
//   ?fx=fade               Variante wählen (gilt nur für diesen Seitenaufruf, nichts wird gespeichert)
//   ?fx=fade&fxspeed=1500  Dauer in ms überschreiben
//   &fxauto=2500           bei Überblendung eigene Dauer für den automatischen Wechsel (siehe getAutoSpeed)
// Ohne Parameter gilt immer der Standard-Slide.
// Nach der Entscheidung die gewählte Variante fest eintragen und den Umschalter entfernen.
const TRANSITIONS = {
  slide: {},
  'slide-ease': { cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)' },
  'slide-soft': { speed: 900, cssEase: 'cubic-bezier(0.65, 0, 0.35, 1)' },
  fade: { fade: true, speed: 1000, cssEase: 'ease-in-out' },
  'fade-slow': { fade: true, speed: 2000, cssEase: 'ease-in-out' },
  cut: { fade: true, speed: 0 },
};

function isTransition(name) {
  return Object.prototype.hasOwnProperty.call(TRANSITIONS, name);
}

function getTransitionOptions() {
  const params = new URLSearchParams(window.location.search);
  const fx = params.get('fx');
  if (!isTransition(fx)) return {};

  const options = { ...TRANSITIONS[fx] };
  const speed = parseInt(params.get('fxspeed'), 10);
  if (speed >= 0) options.speed = Math.min(speed, 5000);
  return options;
}

// ?fxauto=2500: eigene Dauer für den automatischen Wechsel (Autoplay), nur bei Überblendung.
// Wechsel per Pfeil, Punkt, Wischen oder Tastatur behalten die Dauer der Variante bzw. fxspeed.
function getAutoSpeed() {
  const speed = parseInt(new URLSearchParams(window.location.search).get('fxauto'), 10);
  return speed >= 0 ? Math.min(speed, 5000) : null;
}

// Slick kennt nur eine Dauer und liest sie erst nach beforeChange. Eine Eingabe im Slider
// kurz vor dem Wechsel heißt: Besucher hat gewechselt, sonst war es der Autoplay.
function useAutoSpeed($sliders, autoSpeed) {
  $sliders.each(function () {
    const slider = this;
    const manualSpeed = $(slider).slick('slickGetOption', 'speed');
    let lastInput = 0;
    const markInput = () => { lastInput = Date.now(); };
    ['pointerdown', 'pointerup', 'keydown'].forEach(type => slider.addEventListener(type, markInput, true));

    $(slider).on('beforeChange', (event, slick) => {
      const speed = Date.now() - lastInput < 1000 ? manualSpeed : autoSpeed;
      slick.options.speed = speed;
      // Überblendung: altes Bild bleibt genau so lange stehen (gallery.scss)
      slider.style.setProperty('--fx-speed', speed + 'ms');
    });
  });
}

// Galeriebilder ab Slide 2 bringen ihre Quellen in data-* mit (ResponsiveImageGallery.ss).
// Natives loading="lazy" greift im Slider nicht zuverlässig, deshalb laden wir gezielt nach:
// die direkten Nachbarn, sobald das aktuelle Bild da ist und die Galerie in Sicht kommt.
function showImage(img) {
  img.sizes = img.dataset.sizes;
  img.srcset = img.dataset.srcset;
  img.src = img.dataset.src;
  img.removeAttribute('data-sizes');
  img.removeAttribute('data-srcset');
  img.removeAttribute('data-src');
}

function loadAround(slick, index) {
  const count = slick.slideCount;
  const wanted = [index, index + 1, index - 1].map(i => ((i % count) + count) % count);

  // Klone haben Indizes unter 0 bzw. ab slideCount und zeigen dasselbe Bild
  slick.$slider.find('.slick-slide').each(function () {
    const real = ((Number(this.getAttribute('data-slick-index')) % count) + count) % count;
    if (wanted.includes(real)) {
      $(this).find('img[data-srcset]').each(function () { showImage(this); });
    }
  });
}

function onInit(event, slick) {
  const current = slick.$slides.eq(slick.currentSlide).find('img').get(0);
  const loadNeighbours = () => loadAround(slick, slick.currentSlide);

  const whenVisible = () => {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        observer.disconnect();
        loadNeighbours();
      }
    });
    observer.observe(slick.$slider.get(0));
  };

  if (!current || current.complete) {
    whenVisible();
  } else {
    current.addEventListener('load', whenVisible, { once: true });
    current.addEventListener('error', whenVisible, { once: true });
  }
}

function onBeforeChange(event, slick, currentSlide, nextSlide) {
  loadAround(slick, nextSlide);
}

export function setupGallery() {
  if ($('.galleryContainer').length) {

    loadSlick().then(() => {
      const fx = getTransitionOptions();

      const $galleries = $(".galleryContainer:not(.no-autoplay) .content.images")
        .on('init', onInit)
        .on('beforeChange', onBeforeChange)
        .slick({
          dots: true,
          autoplay: true,
          autoplaySpeed: 5000,
          accessibility: true,
          ...fx
        });

      const $manualGalleries = $(".galleryContainer.no-autoplay:not(.teaser-gallery) .content.images")
        .on('init', onInit)
        .on('beforeChange', onBeforeChange)
        .slick({
          dots: true,
          accessibility: true,
          ...fx
        });

      // Erst nach dem Init setzen, sonst blenden beim Laden alle Bilder einmal aus (siehe gallery.scss)
      if (fx.fade) {
        $galleries.add($manualGalleries)
          .addClass('fx-crossfade')
          .css('--fx-speed', fx.speed + 'ms');
      }

      // Slide-Varianten und harter Schnitt bleiben unverändert
      const autoSpeed = getAutoSpeed();
      if (autoSpeed !== null && fx.fade && fx.speed > 0) {
        useAutoSpeed($galleries, autoSpeed);
      }

      // Teaser-Galerie bleibt beim Slide: Überblenden verträgt sich nicht mit centerMode
      $(".galleryContainer.no-autoplay.teaser-gallery .content.images").slick({
        dots: false,
        centerMode: true,
        arrows: false,
        accessibility: true
      });
    });
  }
}
